(function () {

    const getBundleComponents = (handle) => {
        const query = `
            query ProductBundleComponents($handle: String!) {
                        product(handle: $handle) {
                            id
                            title
                            variants(first: 20) {
                                nodes {
                                    id
                                    title
                                    requiresComponents
                                    components(first: 20) {
                                        nodes {
                                            quantity
                                            productVariant {
                                                id
                                                title

                                                sellingPlanAllocations(first: 10) {
                                                    nodes {
                                                        sellingPlan {
                                                            id
                                                            name
                                                            recurringDeliveries
                                                        }
                                                    }
                                                }

                                            product {
                                                    id
                                                    title
                                                    handle
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
        `;

        fetch('/api/2026-04/graphql.json', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': '58875da0238fe3caa2e06cf8df568e1d'
            },
            body: JSON.stringify({
                query,
                variables: {
                    handle
                }
            })
        })
        .then(response => response.json())
        .then(data => {

            console.log(data);
            const fetched_bundle_variants = data?.data?.product?.variants?.nodes || [];

            if(window.product_json.handle == handle) {

                window.product_json.variants.forEach((variant, index) => {
                    variant.bundle_variants = [];
                    variant.selling_plans = []; 
                    fetched_bundle_variants.forEach(fetched_variant => {
                        if(fetched_variant.id.indexOf(variant.id) > 0) {
                            console.log('in if');
                            let variant_components = fetched_variant.components?.nodes || [];
                            variant_components.forEach(variant_component => {
                                variant.bundle_variants.push(variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''));
                                if(variant_component.productVariant.sellingPlanAllocations.nodes.length > 0 && variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan?.id) {
                                    variant.selling_plans.push({'variant_id': variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''), 'selling_plan_id' : variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan.id.replace('gid://shopify/SellingPlan/','')}); // new selling plans
                                }
                            });
                        }
                    });
                });

                console.log(window.product_json.variants);

            } else {
                window.product_json_sibling.variants.forEach((variant, index) => {
                    variant.bundle_variants = [];
                    variant.selling_plans = []; 
                    fetched_bundle_variants.forEach(fetched_variant => {
                        if(fetched_variant.id.indexOf(variant.id) > 0) {
                            console.log('in if');
                            let variant_components = fetched_variant.components?.nodes || [];
                            variant_components.forEach(variant_component => {
                                variant.bundle_variants.push(variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''));
                                if(variant_component.productVariant.sellingPlanAllocations.nodes.length > 0 && variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan?.id) {
                                    variant.selling_plans.push({'variant_id': variant_component.productVariant.id.replace('gid://shopify/ProductVariant/',''), 'selling_plan_id' : variant_component.productVariant.sellingPlanAllocations.nodes?.[0].sellingPlan.id.replace('gid://shopify/SellingPlan/','')}); // new selling plans
                                }
                            });
                        }
                    });
                });

                console.log(window.product_json_sibling.variants);
            }

            
            
        })
        .catch(error => {
            console.error('GraphQL error:', error);
        });
    }

    const replaceCartWithSellingPlan = async (items) => {
        await fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        });

        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items
          })
        });

        console.log(items);
        window.location.href = `/cart`;
    }

    const getBundledItems = (e) => {
        e.preventDefault();

        let btn = e.currentTarget;
        btn.disabled = true;
        console.log(btn);

        let items = [];
        
        window.product_json.variants.forEach((variant) => {
                    
            if(variant.id == btn.dataset.variantid) {

                if(variant.bundle_variants && variant.bundle_variants.length > 0) {
                
                    variant.bundle_variants.forEach(bundle_item => {
                        let item = {
                            quantity: 1
                        };
                        item.id = bundle_item
                        
                        if(variant.selling_plans && variant.selling_plans.length > 0 && variant.selling_plans[0].variant_id == bundle_item) {
                            item.selling_plan = variant.selling_plans[0].selling_plan_id;
                        }

                        items.push(item);
                    });
                }

                window.localStorage.setItem('bundle_added_handle', window.product_json.handle);
                window.localStorage.setItem('bundle_added_handle_vat', window.product_json_vat.handle);
                window.localStorage.setItem('bundle_added_title', window.product_json.title);
                replaceCartWithSellingPlan(items);
            }
        });

        if (items.length == 0) {

            window.product_json_sibling.variants.forEach((variant) => {
                        
                if(variant.id == btn.dataset.variantid) {

                    if(variant.bundle_variants && variant.bundle_variants.length > 0) {
                    
                        variant.bundle_variants.forEach(bundle_item => {
                            let item = {
                                quantity: 1
                            };
                            item.id = bundle_item
                            
                            if(variant.selling_plans && variant.selling_plans.length > 0 && variant.selling_plans[0].variant_id == bundle_item) {
                                item.selling_plan = variant.selling_plans[0].selling_plan_id;
                            }

                            items.push(item);
                        });
                    }

                    window.localStorage.setItem('bundle_added_handle', window.product_json_sibling.handle);
                    window.localStorage.setItem('bundle_added_title', window.product_json_sibling.title);
                    replaceCartWithSellingPlan(items);
                }
            });

        }

    
    }

    
	const initUnbundler = () => {

        getBundleComponents(window.product_json.handle);

        if(window.product_json_sibling) {
            getBundleComponents(window.product_json_sibling.handle);
        }

        const addToCartBtns = document.querySelectorAll('variant-radios-custom .button');

        addToCartBtns.forEach(btn => {
            console.log(btn);
            btn.addEventListener('click', getBundledItems);
        });
		
	};

	document.addEventListener("shopify:section:load", function () {
		initUnbundler();
	});

	initUnbundler();
})();